export default {
    AUTH_TOKEN:"ta-token",
    AUTH_TRADING_ID:"ta-trading-id",
    AUTH_REMEMBER_ME:"ta-remember-me",
    LOGOUT:"logout",
    SET_OFF:"set-off",
    SET_OFF_TYPE:"offset",
    PAYMENT_TYPE:"payment",
    WITHDRAWAL_TYPE:"withdrawal",
    P_L_CALCULATOR: "p-and-l-calculator",
    MARGIN_CALCULATOR: "margin-calculator",
    TRANSFER_IN: "Transfer-in",
    TRANSFER_OUT: "Transfer-out",
    CASH_IN: "Cash-in",
    CASH_OUT: "Cash-out",
    BUY_IN: "Buy",
    SELL_OUT: "Sell",
    DIRECT_TRANSFER:"direct_transfer",
    CASH:"cash",
    CHEQUE:"cheque",
    STATUS_PENDING:"PENDING",
    STATUS_SUBMITTED:"SUBMITTED",
    STATUS_CANCELLED:"CANCELLED",
    STATUS_FILLED:"FILLED",
    STATUS_ERROR:"ERROR",
    STATUS_EXPIRED:"EXPIRED",
    STATUS_REJECTED:"REJECTED",
    STATUS_REQUEST_CANCEL:"REQUEST_CANCEL",
    STATUS_CANCEL_SUBMITTED:"CANCEL_SUBMITTED",
    STATUS_CANCELLED_CONFIRMED:"CANCELLED_CONFIRMED",
    STATUS_PAYMENT_PENDING:'pending',
    STATUS_PAYMENT_PAYMENT_MADE:'payment_made',
    STATUS_PAYMENT_APPROVED:'approved',
    STATUS_PAYMENT_REJECTED:'rejected',
    STATUS_PAYMENT_ERROR:'error',
    STATUS_PAYMENT_CANCELLED:'cancelled',
    ORDER_BY_ASC:'asc',
    ORDER_BY_DESC:'desc',
}
